import React from "react";
import { NavigationalButtons } from "./CreateCourseWizard";
import { Form, Formik } from "formik";
import ActionPlanAnalysisList from "../ActionPlanAnalysis/ActionPlanAnalysisList";

const ActionPlanAnalysisStep = ({ courseId, revId, nextOnClick, prevOnClick }) => {

    return (
        <div>
            <ActionPlanAnalysisList crsId={courseId} revId={revId} />
            <Formik
                initialValues={{}}
                onSubmit={async () => {
                    nextOnClick();
                }}
            >
                <Form>
                    <NavigationalButtons
                        onNextProps={{ type: "submit", text: "Save and Continue" }}
                        onPrevHandler={prevOnClick}
                    />
                </Form>
            </Formik>
        </div>
    );
};

export default ActionPlanAnalysisStep;
